<template>
  <div id="admin">
    <Menutop></Menutop>

    <div class="row container">
      <div class="col">


        <h1>Hier ist admin</h1>

        <b-button @click="customers_fetch_anstossen">Hole Customers von Findus-Server</b-button>

      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios';
import Menutop from '../components/Menutop.vue';
import Footer from '../components/Footer.vue';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';

export default {
  components: {
    Menutop,
    Footer
  },
  mixins: [
    loginzustand,
    commonvars
  ],
  data() {
    return {
      customers: []
    }
  },
  mounted: function() {
    this.api_loginzustand_feststellen();
  },
  methods: {

    customers_fetch_anstossen() {
      let url = this.api_customers_fetch_url();
      console.log(url);
      axios
        .get (url)
        .then(
        response => {
            console.log(response.data);
            this.customers = response.data["customers"];
          
        }
      ); 
    },

    api_customers_fetch_url() {
      return this.server_base_url()
          + '/api/hole/customers/von/findusserver';
    },
  }
}
</script>